<div [ngClass]="{ 'input-group-sm': small_input, 'input-group': true }">
  <input
    [(ngModel)]="recipientSearchTerm"
    type="text"
    [appAutocomplete]="'/documents/get_recipients'"
    [include_item]="include_item"
    (autocompleteSelect)="recipientSearchOnSelect($event)"
    [placeholder]="placeholder || 'Search for recipient'"
    class="form-control"
    [disabled]="!select_only && (!!recipientId || !editable)"
    name="recipient-search"
    ngDefaultControl
  />
  <div class="input-group-append" *ngIf="!select_only">
    <button type="button" class="btn btn-primary" [disabled]="!recipientId || !editable" (click)="clearSelectedRecipient()">
      <span class="fas fa-pencil-alt"></span>
    </button>
  </div>
</div>
